import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
})
export class AppointmentComponent implements OnInit , OnDestroy{
  constructor() {}

  ngOnInit(): void {}
  ngOnDestroy() {

  }
}
